export const SPECIES_META = {
  CYPRINUS_CARPIO: { is_predator: false },
  CTENOPHARYNGODON_IDELLA: { is_predator: false },
  SILURUS_GLANIS: { is_predator: true },
  PERCA_FLUVIATILIS: { is_predator: true },
  RUTILUS_RUTILUS: { is_predator: false },
  BARBUS_BARBUS: { is_predator: false },
  CHONDROSTOMA_NASUS: { is_predator: false },
  SALMO_TRUTTA: { is_predator: true },
  LEPOMIS_GIBBOSUS: { is_predator: true },
  CARASSIUS_CARASSIUS: { is_predator: false },
  SCARDINIUS_ERYTHROPHTHALMUS: { is_predator: false },
  ESOX_LUCIUS: { is_predator: true },
  HYPOPHTHALMICHTHYS_MOLITRIX: { is_predator: false },
  HYPOPHTHALMICHTHYS_NOBILIS: { is_predator: false },
  TINCA_TINCA: { is_predator: false },
  ASPIUS_ASPIUS: { is_predator: true },
  PELECUS_CULTRATUS: { is_predator: false },
  GOBIO_GOBIO: { is_predator: false },
};
